module.exports = __webpack_public_path__ + "static/bg-4f015ceeec603e851249ee5f1e7d0e78.svg";